import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './SupabaseAuthContext';

const DiscreteContext = createContext();

const DISCRETE_MODE_KEY = 'footparadise_discrete_mode';

// Per-account, like DarkModeContext — see comment there.
function readStored(userId) {
  return localStorage.getItem(`${DISCRETE_MODE_KEY}::${userId}`) === 'true';
}

export function DiscreteProvider({ children }) {
  const { user } = useAuth();
  const userId = user?.id || 'guest';
  const [isDiscreteMode, setIsDiscreteMode] = useState(() => readStored(userId));

  useEffect(() => {
    setIsDiscreteMode(readStored(userId));
  }, [userId]);

  useEffect(() => {
    localStorage.setItem(`${DISCRETE_MODE_KEY}::${userId}`, isDiscreteMode.toString());
  }, [isDiscreteMode, userId]);

  const toggleDiscreteMode = () => {
    setIsDiscreteMode(prev => !prev);
  };

  // Strong blur style for images
  const discreteBlurStyle = isDiscreteMode ? {
    filter: 'blur(20px)',
    WebkitFilter: 'blur(20px)',
  } : {};

  return (
    <DiscreteContext.Provider value={{
      isDiscreteMode,
      toggleDiscreteMode,
      discreteBlurStyle
    }}>
      {children}
    </DiscreteContext.Provider>
  );
}

export function useDiscrete() {
  const context = useContext(DiscreteContext);
  if (!context) {
    throw new Error('useDiscrete must be used within a DiscreteProvider');
  }
  return context;
}

export default DiscreteContext;
